export const isUnathorized = (response: Response) => {
  if ([401, 403].includes(response.status)) {
    console.error(`Received status: ${response.status} - ${response.statusText}. Logout!`);
    window.parent.location.href = 'https://turnieje.azurewebsites.net/Account/Logout';
  }
};
